import React, { useState } from 'react';
import {
  Drawer,
  DrawerProps,
  Button,
  Panel,
  Placeholder,
  Stack,
  InputGroup,
  InputNumber,
  Col,
  Row,
  Checkbox,
  Radio,
  SelectPicker,
  Form,
  RadioGroup,
  Divider
} from 'rsuite';
import img from '../../assets/images/items/img1.jpg'
import DrawerVieweee from './DrawerVieweee';

const DrawerViewee = (props: DrawerProps) => {

  const [showDrawer, setShowDrawer] = useState(false);
  const [size, setSize] = React.useState('xs');
  const [value, setValue] = React.useState(1);
  const { onClose, ...rest } = props;

  const extend = () => {
    setSize('lg')
    let y = document.getElementById('b')
    let x = document.getElementById('a')
    y.style.display = "block"
    x.style.width = '50%'
  }

  function handleCountChange() {
    if (value === 1) {
      setValue(2);
    } else if (value === 2) {
      setValue(3);
    } else {
      setValue(1);
    }
  }

  const sort = ['Product ID', 'Sub Category', 'Color', 'Name', 'Selling Price', 'MOQ'].map(
    item => ({ label: item, value: item })
  );

  return (
    <Drawer backdrop="static" size={size} placement="right" onClose={onClose} {...rest}>
      <Drawer.Header>
        <Drawer.Actions>
          <Button onClick={onClose} appearance="ghost" color='cyan'>
            Previous
          </Button>
          <Button color="cyan" appearance="primary" >
            Done
          </Button>
        </Drawer.Actions>
      </Drawer.Header>
      <Drawer.Body>
        <Row>
          <Col xs={24} id='a'>
            <Panel >
              <div style={{ marginBottom: '22px', marginLeft: '-7px' }}>
                <b> Select number of images and template</b>
              </div>
              <Stack justifyContent='space-between' >
                <p>No. of images on each slide:</p>
                <InputGroup style={{ width: 100 }}>
                  <InputNumber value={value} onChange={handleCountChange} defaultValue={1} min={1} max={3} />
                </InputGroup>
              </Stack>
            </Panel>
            <Panel >
              {value === 1 ? (
                <div>
                  <Stack direction='column' spacing={30}>
                    <Stack spacing={5} justifyContent='space-between'>
                      <Stack direction='column' alignItems='flex-start'>
                        <Button appearance="default" style={{ border: '1px dotted gray' }} onClick={extend}>
                          <Panel {...props} style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>PORTRAIT - 2 </b>
                      </Stack>
                      <Stack direction='column' alignItems='flex-start'>
                        <Button appearance="default" style={{ border: '1px dotted gray' }} onClick={extend}>
                          <Panel {...props} style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>LANDSCAPE - 3</b>
                      </Stack>
                    </Stack>
                    <Stack spacing={5} justifyContent='space-between'>
                      <Stack direction='column' alignItems='flex-start'>
                        <Button appearance="default" style={{ border: '1px dotted gray' }} onClick={extend}>
                          <Panel {...props} style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>PORTRAIT - 3</b>
                      </Stack>
                      <Stack direction='column' alignItems='flex-start'>
                        <Button appearance="default" style={{ border: '1px dotted gray' }} onClick={extend}>
                          <Panel {...props} style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>PORTRAIT - 1</b>
                      </Stack>
                    </Stack>
                  </Stack>
                </div>
              ) : null}
              {value === 2 ? (
                <div>
                  <Stack direction='column' spacing={30}>
                    <Stack spacing={5} justifyContent='space-between'>
                      <Stack direction='column' alignItems='flex-start'>
                        <Button appearance="default" style={{ border: '1px dotted gray' }} onClick={extend}>
                          <Panel {...props} style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>2 LANDSCAPE IMAGES</b>
                      </Stack>
                      <Stack direction='column' alignItems='flex-start'>
                        <Button appearance="default" style={{ border: '1px dotted gray' }} onClick={extend}>
                          <Panel {...props} style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>2 PORTRAIT IMAGES</b>
                      </Stack>
                    </Stack>
                    <Stack spacing={5} justifyContent='space-between'>
                      <Stack direction='column' alignItems='flex-start'>
                        <Button appearance="default" style={{ border: '1px dotted gray' }} onClick={extend}>
                          <Panel {...props} style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>1 LAND... & 1 PORT...</b>
                      </Stack>
                      <Stack direction='column' alignItems='flex-start'>
                        <Button appearance="default" style={{ border: '1px dotted gray' }} onClick={extend}>
                          <Panel {...props} style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>2 PORTRAIT IMAGES</b>
                      </Stack>
                    </Stack>
                  </Stack>
                </div>
              ) : null}
              {value === 3 ? (
                <div>
                  <Stack direction='column' spacing={30}>
                    <Stack spacing={5} justifyContent='space-between'>
                      <Stack direction='column' alignItems='flex-start'>
                        <Button appearance="default" style={{ border: '1px dotted gray' }} onClick={extend}>
                          <Panel {...props} style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>3 PORTRAIT IMAGES</b>
                      </Stack>
                      <Stack direction='column' alignItems='flex-start'>
                        <Button appearance="default" style={{ border: '1px dotted gray' }} onClick={extend}>
                          <Panel {...props} style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>PORTRAIT LAYOUT -1</b>
                      </Stack>
                    </Stack>
                    <Stack spacing={5} justifyContent='space-between'>
                      <Stack direction='column' alignItems='flex-start'>
                        <Button appearance="default" style={{ border: '1px dotted gray' }} onClick={extend}>
                          <Panel {...props} style={{ width: 150 }}>
                            <Placeholder.Paragraph />
                          </Panel>
                        </Button>
                        <b>3 PORTRAIT IMAGES</b>
                      </Stack>
                    </Stack>
                  </Stack>
                </div>
              ) : null}
            </Panel>
          </Col>
          <Col xs={12} style={{ display: 'none' }} id='b'>
            <Panel >
              <div style={{ marginBottom: '22px', marginLeft: '-7px' }}>
                <b> Preview</b>
              </div>
              <Stack direction='column' alignItems='flex-start' >
                <p>This works best to showcase multiple angles of the product</p>
                <img src={img} className='imgp' />
              </Stack>
              <Panel>
                <Stack direction='column' spacing={10} alignItems='flex-start'>
                  <b>Select the order in which the products get sorted</b>
                  <Panel >
                    <Form.Group controlId="radioList">
                      <RadioGroup name="radioList">
                        <Stack direction='column' alignItems='flex-start'>
                          <Radio value="A"><b> Autogenerated </b></Radio>
                          <p style={{ marginLeft: '35px' }}>Customize the order of products</p>
                        </Stack>
                        <Divider />
                        <Stack direction='column' alignItems='flex-start'>
                          <Radio value="B"><b> Sorted by Category and Product ID </b></Radio>
                          <Form.Group controlId="name-1">
                            <Form.ControlLabel style={{ marginLeft: '35px' }}>Sort the product by</Form.ControlLabel>
                            <SelectPicker data={sort} menuStyle={{ maxHeight: '200px' }} style={{ width: 300, marginLeft: '35px' }} placement="bottomEnd" />
                          </Form.Group>
                        </Stack>
                      </RadioGroup>
                    </Form.Group>
                  </Panel>
                </Stack>
              </Panel>
              <Checkbox><b> Set as default template </b></Checkbox>
              <p style={{ marginLeft: '35px' }}>This will be preselected as a default template</p>
            </Panel>
          </Col>
        </Row>
      </Drawer.Body>
      <DrawerVieweee open={showDrawer} onClose={() => setShowDrawer(false)} />
    </Drawer>
  );
};

export default DrawerViewee;